import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

import styles from './analytics-status.module.css';

export function SeeAllButton() {
    return (
        <div className={styles['see-all']}>
            <Link
                // @ts-expect-error
                as={RoutedLink}
                variant='primary'
                size='normal'
                to='/email-marketing/connected-forms'
            >
                See all
            </Link>
        </div>
    );
}
